<template>
  <div>
    <!-- If USER IS NOT VERIFIED-->
    <div v-if="!isUserVerified">
      <!-- check if has a pending verification status -->
      <div
        v-if="userProfile.profile_details.valid_ids[0].verification_status === undefined ||
          userProfile.profile_details.valid_ids[0].verification_status !== 'pending'"
      >
        <p class="pass-step-description notice-important">
          Oops! We need you to get verified to get this pass.
        </p>
        <button @click="goToVerifyAccount()" class="btn-primary pass-step-primary-btn">
          Get verified
        </button>
      </div>
      <div v-else>
        <!-- USER HAS PENDING VERIFICATION APPLICATION -->
        <p class="pass-step-description notice-important">
          Your account have a pending verification.
          <br>Please wait on the verification process to complete.
        </p>
      </div>
    </div>
    <div v-else>
      <!-- USER IS VERIFIED -->
      <p class="pass-step-description notice-positive">
        You may now proceed to the next step.
      </p>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/pass-share-steps.css'

export default {
  name: 'step-verify',
  data() {
    return {}
  },
  mounted() {
    // console.log('userProfile: ', this.userProfile)
  },
  props: {
    goToUrl: String,
    isUserVerified: Boolean,
    userProfile: Object
  },
  methods: {
    goToVerifyAccount() {
      this.$router.push('/dashboard/verify-account?page_origin')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/share/passes/PassShareStepVerify.vue